import { CategoryType } from "@core/schema/CategoryType.js";
import { Locale, type LocalizedString } from "@core/schema/Locale.js";
import type { ProductForCustomer } from "@core/schema/Product.js";
import type { SubcategoryForCustomer } from "@core/schema/Subcategory.js";
import { isProductConsideredNew } from "@core/schema/utils/isProductConsideredNew.js";
import { tw } from "@core/utils/svelte/tw.js";
import type { ProductTagsDefinition } from "./ProductTagsDefinition.js";

const newTagClass = tw("!border-[3.75px] !py-0 border-fcrdarkblue !text-fcrdarkblue font-antipol-extended");
const newLabel: LocalizedString = {
	[Locale.cs]: "Nové",
	[Locale.en]: "New",
};

/**
 * Returns the standard tags for product card:
 * - New, if the product can be {@link isProductConsideredNew considered new}
 * - The subcategory
 */
export function getTagsForProductCard({
	locale,
	product,
	subcategory,
}: {
	product: ProductForCustomer;
	subcategory?: SubcategoryForCustomer;
	locale: Locale;
}): ProductTagsDefinition {
	const tags: ProductTagsDefinition = {};
	if (subcategory?.category === CategoryType.Coffee) {
		tags[subcategory.name[locale]] = { background: subcategory.icon?.color };
	}
	if (isProductConsideredNew(product)) {
		tags[newLabel[locale]] = { class: newTagClass };
	}
	return tags;
}
